export const environment = {
  apiUrl: 'https://api-dev.blinth.it',
  webSocketUrl: 'wss://api-dev.blinth.it/ws',
  s3BaseUrl: 'https://direct-manager-dev.s3.eu-central-1.amazonaws.com/',
  dev: true,
  prod: false,
  app: false
};
